<button class='question' [tooltip]='text' type='button'></button>
